import React from 'react'
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
import LazyLoad from "react-lazyload";
const FullAttendance = () => {
    return (
        <>
            <Header />
            <Breadcrumb mid="Academics" breadcrumbName="Full Attendance" />
            <div className="innerSection">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="title">
                                <div>
                                    <h1>Full Attendance</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className='col-12'>
                            <h3 className='heading'><b>Nursery B</b></h3>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/NUR-B.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> VIRAJ YADUVANSHI</h4>
                                <p>  NUR-B </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/NUR-B-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> Daivik Sharma </h4>
                                <p> NURSERY B</p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className='col-12'>
                            <h3 className='heading'><b>LKG</b></h3>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/LKG-A.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>SHIVANYA </h4>
                                <p>LKG A</p>
                            </div>
                        </div>
                    </div>

                    <div className="row g-4">
                        <div className='col-12'>
                            <h3 className='heading'><b>Class I</b></h3>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class1-1A.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> Devanshi Saroj </h4>
                                <p> 1 A</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class1-1A-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Reyansh Raj </h4>
                                <p> I A</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class1-1C.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>AADITYA SINGH  </h4>
                                <p>1 C</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class1-1C-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> ANYA GUPTA  </h4>
                                <p> 1 C</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class1-1C-2.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>SARTHAK BARANWAL </h4>
                                <p> 1 C</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class1-1E.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>MIHIT AGRAWAL</h4>
                                <p>1 E </p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className='col-12'>
                            <h3 className='heading'><b>Class II</b></h3>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class2-2A.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>  ABHISHREE MISHRA </h4>
                                <p> II A</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class2-2B.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>KALASH SRIVASTAVA </h4>
                                <p>II B</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class2-2B-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>ANUSHREE SHARMA  </h4>
                                <p>II B</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class2-2B-2.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> PRAGATI JAISWAL </h4>
                                <p>2 B</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class2-2D.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>SARTHAK SINGH </h4>
                                <p>2 D</p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className='col-12'>
                            <h3 className='heading'><b>Class III</b></h3>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class3-2B.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>NILESH GUPTA  </h4>
                                <p>3 B</p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className='col-12'>
                            <h3 className='heading'><b>Class IV</b></h3>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class4-4C.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>APEKSHA SINGH  </h4>
                                <p>4 C</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class4-4C-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>SHIVANSH DUBEY </h4>
                                <p>4 C</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class4-4D.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>PRIYAL SAHU </h4>
                                <p>4 D</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class4-4E.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>AKSHITA ARYA  </h4>
                                <p>IV E</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class4-4E-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>APARNA MAURYA  </h4>
                                <p>IV E</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class4-4E-2.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>HASHI </h4>
                                <p> IV E </p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class4-4E-3.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>PRANJAL YADAV </h4>
                                <p> IV E </p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className='col-12'>
                            <h3 className='heading'><b>Class V</b></h3>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class5-VA.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>ABHIGYAN DEO PANDEY </h4>
                                <p>V A</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class5-VA-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>Shweta Jha  </h4>
                                <p>V A</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class5-VC-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>GUNJAN RAI </h4>
                                <p>V C</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class5-VC.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>ANANYA JAISWAL </h4>
                                <p>V C</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class5-VD-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>PIYUSH DUBEY </h4>
                                <p>V D</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class5-VE.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>SHIADRIJA SINGH </h4>
                                <p>V E</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class5-VE-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>ARYAN SRIVASTAVA </h4>
                                <p>V E</p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className='col-12'>
                            <h3 className='heading'><b>Class VI</b></h3>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class6-VA.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>MRITYUNJAY</h4>
                                <p>VI A</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class6-VB.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>AVYA YADAV </h4>
                                <p>VI B</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class6-VB-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>ANUPRIYA YADAV </h4>
                                <p>VI B</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class6-VB-2.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>ARPIT VERMA </h4>
                                <p>VI B</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class6-VB-3.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>DIVYANSH KUMAR BIND  </h4>
                                <p>VI B</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class6-VB-4.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>VISHISHT PANDEY</h4>
                                <p>VI B</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class6-Vc-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>DIVYANSH SHARMA </h4>
                                <p>VI C</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class6-Vc-2.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>KHUSHI </h4>
                                <p>VI C</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class6-VD-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>ANUSHKA RANJAN</h4>
                                <p>VI D</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class6-VE-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>AAKASH SINGH</h4>
                                <p>VI E</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class6-VE-2.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>ADITYA PRATAP SINGH </h4>
                                <p>VI E</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class6-VE-3.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> AVIRAL SINGH 6E </h4>
                                <p>VI E</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class6-VE-4.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>DIVYANSH MAURYA </h4>
                                <p>VI E</p>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        <div className='col-12'>
                            <h3 className='heading'><b>Class VII</b></h3>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VII-A.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>SHREYA SHARMA </h4>
                                <p>VII A</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VII-B.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>AARAV</h4>
                                <p>VII B</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VII-B-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>ANIMESH AGRAWAL </h4>
                                <p>VII B</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VII-B-2.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>UTKARSH PATEL </h4>
                                <p>VII B</p>
                            </div>
                        </div>



                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VII-C-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>ANSHIKA RAJ </h4>
                                <p>VII C</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VII-C-2.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>AYUSH KUMAR SINGH </h4>
                                <p>VII C</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VII-C-3.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>BIHAN JAISWAL </h4>
                                <p>VII C</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VII-C-4.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>PRATIKSHA SINGH </h4>
                                <p>VII C</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VII-C-5.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>SANYA PATEL </h4>
                                <p>VII C</p>
                            </div>
                        </div>


                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VII-C-6.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>SHYAM NAND YADAV 7C</h4>
                                <p>VII C</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VII-D-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>VINSHA YADUVANSHI</h4>
                                <p>VII D</p>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VII-E-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> AYANSH PRATAP YADAV </h4>
                                <p>VII E</p>
                            </div>
                        </div>








                    </div>
                    <div className="row g-4">
                        <div className='col-12'>
                            <h3 className='heading'><b>Class VIII</b></h3>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VIII-C.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>ABHINAV JHA</h4>
                                <p>VIII C</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VIII-C-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>ARYAVEER SINGH </h4>
                                <p>VIII C</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VIII-E-1.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4> DEVESH GUPTA </h4>
                                <p>VIII E</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-VIII-E-2.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>PRATYUSH TIWARI</h4>
                                <p>VIII E</p>
                            </div>
                        </div>
                    </div>

                    <div className="row g-4">
                        <div className='col-12'>
                            <h3 className='heading'><b>Class IX</b></h3>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-IX-A.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>SAKSHI PRIYA </h4>
                                <p>IX A</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                            <div className="common-box">
                                <LazyLoad>
                                    <img src="https://webapi.entab.info/api/image/SMSMU/public/Images/class-IX-B.jpg" alt="St mary school, mirzapur" />
                                </LazyLoad>
                                <h4>  GAURAV SINGH</h4>
                                <p>IX B</p>
                            </div>
                        </div>

                        </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default FullAttendance